import React, { useEffect, useState } from "react"

import './PageBody.css'
import { ContactsPage } from "@/env/contact"
import { Translates } from "@/services/repository/i18n"
import { ContactBox } from "./Contact"

interface Props {
  translates: Translates,
  title: string
  contacts: ContactsPage
}

interface Image {
  url: string
}

export const ContactPageBody: React.FC<Props> = ({
  title,
  translates,
  contacts
}) => {

  return <div className="contact-page-body">
    { title ? <div className="title">{translates.for(title)}</div> : null }
    <ContactBox contacts={contacts} translates={translates} />
  </div>
}